import { Color, ZoneType } from "@fairfleet/geotab";
import { zoneTypeId } from "./zoneTypeId";

/** Blue, half transparent: Geotab's own default for zones of type "Other". */
export const FALLBACK_ZONE_COLOR: Color = { r: 33, g: 150, b: 243, a: 160 };

export function defaultColorForTypes(typeIds: string[], types: ZoneType[]): Color {
  for (const id of typeIds) {
    const color = types.find(type => zoneTypeId(type) === id)?.fillColor;
    if (color) return color;
  }
  return FALLBACK_ZONE_COLOR;
}

export function colorToRgba(color: Color, alpha?: number): [number, number, number, number] {
  return [color.r, color.g, color.b, alpha ?? color.a];
}

const hex = (value: number) => Math.round(value).toString(16).padStart(2, "0");

/** `#rrggbb` – what `<input type="color">` reads and writes; alpha is kept separately. */
export function colorToCss(color: Color): string {
  return `#${hex(color.r)}${hex(color.g)}${hex(color.b)}`;
}

export function cssToColor(css: string, alpha: number): Color {
  return {
    r: parseInt(css.slice(1, 3), 16),
    g: parseInt(css.slice(3, 5), 16),
    b: parseInt(css.slice(5, 7), 16),
    a: alpha,
  };
}
